module.exports = __webpack_public_path__ + "static/media/miterCorrect.7f74c2d9.png";